/**
 *
 * @param cursorPosition
 * @constructor
 */

import { ActionState, ActionStateEnum, IdleConstruction } from "..";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { EntityManager } from "../../plan/EntityManager";
import { PlanManager } from "../../../../cocosPlan";
import { Commands, Events, eventsManager, math, Room, roomManager, SavaneConstants, SavaneMath, SceneConstants, Wall, wallManager } from "@rhinov/savane-js";

declare var cc: any;


export class EditPointState extends ActionState {

    static EDITED_POINT_NODE_NAME: string = 'EditedJunctionPoint';

    state: number = ActionStateEnum.editPoint;
    _wallsEdited: Wall[] | null;
    _cursorPosition: math.vec3;
    _beginPointPosition: math.vec3;

    editionDone: boolean = false;

    //room test
    editedRooms: Room[] = [];

    _endWallsSelected: Wall[] | null = null;
    _anglesToDraw: [Wall, [Wall]][] = [];
    _beginWallsSelected: Wall[] = [];
    roomsToUpdate: Room[] = [];

    constructor(cursorPosition: math.vec3) {
        super();
        var i, j, k;
        
        this._wallsEdited = wallManager.getWallsAtCorner(cursorPosition, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance);

        this._cursorPosition = math.vec3.clone(cursorPosition);
        this._beginPointPosition = math.vec3.clone(cursorPosition);

        

        for (i = 0; i < this._wallsEdited!.length; i++) {
            var wall = this._wallsEdited![i];
            wall.startTemporary();
            //wall.temporary.canBeSuperposed = true;
            for (j = 0; j < wall.rooms.length; j++) {
                var room = wall.rooms[j];
                if (this.editedRooms.indexOf(room) === -1) {
                    this.editedRooms.push(room);
                }
            }
            var roomCleaned = roomManager.deleteNonRoomedWall(wall.id, PlanManager.getInstance().world.currentScene!.currentFloor!);
            if (roomCleaned !== null) {
                GameObjectManager.drawRoom(roomCleaned, false, null, false);
            }
        }

        for (i = 0; i < this._wallsEdited!.length; i++) {
            var otherPoint = this._wallsEdited![i].isBegin(cursorPosition) ? this._wallsEdited![i].end : this._wallsEdited![i].begin;
            var walls = wallManager.getWallsAtCorner(otherPoint, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance);

            if (walls !== null && walls.length > 1) {
                for (j = walls.length - 1; j >= 0; j--) {
                    if (walls[j].isTemporary()) {
                        walls.splice(j, 1);
                    } else if (this._beginWallsSelected.indexOf(walls[j]) === -1) {
                        this._beginWallsSelected.push(walls[j]);
                    }
                }
                if (walls !== null && walls.length > 0) {
                    this._anglesToDraw.push([walls[0], [this._wallsEdited![i]]]);
                }
            }
        }

        if (this._wallsEdited!.length === 2) {
            this._anglesToDraw.push([this._wallsEdited![1], [this._wallsEdited![0]]]);
        }

        
        for (i = 0; i < this._wallsEdited!.length; i++) {
            for (j = 0; j < this._wallsEdited![i].rooms.length; j++) {
                var alreadyIn = false;
                for (k = 0; k < this.roomsToUpdate.length; k++) {
                    if (this._wallsEdited![i].rooms[j].id === this.roomsToUpdate[k].id) {
                        alreadyIn = true;
                    }
                }
                if (!alreadyIn) {
                    this.roomsToUpdate.push(this._wallsEdited![i].rooms[j]);
                }
            }
        }
        var roomList = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
        for (i = 0; i < roomList.length; i++) {
            if (this.roomsToUpdate.indexOf(roomList[i]) >= 0)
                continue;
            var innerRoom = roomList[i].getInnerRoomList(false);
            for (j = 0; j < this.roomsToUpdate.length; j++) {
                if (innerRoom.indexOf(this.roomsToUpdate[j]) >= 0) {
                    this.roomsToUpdate.push(roomList[i]);
                    break;
                }
            }
            if (this.roomsToUpdate.indexOf(roomList[i]) >= 0)
                continue;

            for (k = 0; k < this._wallsEdited!.length; k++) {
                if (roomList[i].nonRoomedWalls.indexOf(this._wallsEdited![k]) >= 0) {
                    this.roomsToUpdate.push(roomList[i]);
                    continue;
                }
            }
        }
    }

    getAction (): number {
        return ActionStateEnum.editPoint;
    }

    get beginPoint(): math.vec3 | null {
        if (this._wallsEdited!.length === 1) {
            return this._wallsEdited![0].isBegin(this._cursorPosition) ? this._wallsEdited![0].end : this._wallsEdited![0].begin;
        }
        return null;
    }

    get editedPoint(): math.vec3 {
        return this._cursorPosition;
    }


    get wallsEdited(): Wall[] | null {
        return this._wallsEdited;
    }

    moveMouseCursor (cursorPosition: math.vec3, wallsSelected?: Wall[], planpos?: math.vec3): ActionState | null {
        super.moveMouseCursor(cursorPosition);
        for (i = 0; i < this._wallsEdited!.length; i++) {
            if (this._wallsEdited![i].locked) {
                return null;
            }
        }

        var i, j;
        var wall, position;
        for (i = 0; i < this._wallsEdited!.length; i++) {
            wall = this._wallsEdited![i];
            var distOnWall = [];
            var direction = math.vec3.clone(wall.wallDirection);
            if (wall.isBegin(this._cursorPosition)) {
                for (j = 0; j < wall.joineries.length; j++) {
                    if (wall.joineries[j].joineryType !== SceneConstants.JoineryType.velux) {
                        distOnWall.push(math.vec2.dist(wall.shiftedEnd, wall.joineries[j].position));
                    }
                }
                wall.begin = cursorPosition;
                for (j = 0; j < wall.joineries.length; j++) {
                    if (wall.joineries[j].joineryType !== SceneConstants.JoineryType.velux) {
                        position = math.vec3.clone(wall.joineries[j].position);
                        position[0] = wall.shiftedEnd[0] - direction[0] * distOnWall[j];
                        position[1] = wall.shiftedEnd[1] - direction[1] * distOnWall[j];
                        wall.joineries[j].position = position;
                    }
                    else {
                        wall.joineries[j].transform.localMatrix[12] = wall.joineries[j].transform.localMatrix[12];
                    }
                }
            } else {
                for (j = 0; j < wall.joineries.length; j++) {
                    distOnWall.push(math.vec2.dist(wall.shiftedBegin, wall.joineries[j].position));
                }
                wall.end = cursorPosition;
                for (j = 0; j < wall.joineries.length; j++) {
                    if (wall.joineries[j].joineryType !== SceneConstants.JoineryType.velux) {
                        position = math.vec3.clone(wall.joineries[j].position);
                        position[0] = wall.shiftedBegin[0] + direction[0] * distOnWall[j];
                        position[1] = wall.shiftedBegin[1] + direction[1] * distOnWall[j];
                        wall.joineries[j].position = position;
                    }
                }
            }
        }
        var isValid = true;
        for (i = 0; i < this._wallsEdited!.length; i++) {
            wall = this._wallsEdited![i];
            var isWallValid = wall.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!);
            GameObjectManager.drawWall(wall, isWallValid, true, false);
            isValid = isValid ? isWallValid : false;
        }

        this.updateAdjacentWalls(wallsSelected!);

        //What's the point of these lines ?
        /*if (isValid) {
            GameObjectManager.updateRooms(this.roomsToUpdate, false, null, false);
        } else {
            for (i = 0; i < this.roomsToUpdate.length; i++) {
                EntityManager.getInstance().deleteNodeAndChild(this.roomsToUpdate[i]);
            }
        }*/
        GameObjectManager.updateRooms(this.roomsToUpdate, false);
        math.vec3.copy(this._cursorPosition, cursorPosition);

        return null;
    }

    mouseClickUp (cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Wall[], mouseButton: number): ActionState | null {
        for (i = 0; i < this._wallsEdited!.length; i++) {
            if (this._wallsEdited![i].locked) {
                return null;
            }
        }
        var i;
        var isValid = true;
        this.editionDone = true;

        for (i = 0; i < this._wallsEdited!.length; i++) {
            var wall = this._wallsEdited![i];
            isValid = isValid ? wall.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!) : false;
        }

        for (i = 0; i < this._wallsEdited!.length; i++) {
            this._wallsEdited![i].endTemporary();
        }
        for (i = 0; i < this._wallsEdited!.length; i++) {
            GameObjectManager.drawWall(this._wallsEdited![i], true, false, false);
        }
        
        this.updateAdjacentWalls(hoverEntities);

        if (isValid && math.vec3.distance(this._beginPointPosition, cursorPosition) > SavaneConstants.PositionTolerance) {
            PlanManager.getInstance().executeCommand(new Commands.EditPointCommand(this._beginPointPosition, cursorPosition, PlanManager.getInstance().world.currentScene!.currentFloor!, PlanManager.getInstance().selectedEntities));
        }

        if (this._anglesToDraw !== null) {
            for (i = 0; i < this._anglesToDraw.length; i++) {
                GameObjectManager.deleteAngle(this._anglesToDraw[i][0]);
            }
        }

        return new IdleConstruction();
    }

    updateAdjacentWalls (wallsSelected: Wall[]) {
        var i, j;
        if (this._endWallsSelected !== null) {
            for (i = 0; i < this._endWallsSelected.length; i++) {
                GameObjectManager.drawWall(this._endWallsSelected[i], true, false, false);
            }
        }
        var zoom = PlanManager.getInstance().getZoomScale();
        if (this._beginWallsSelected !== null) {
            for (i = 0; i < this._beginWallsSelected.length; i++) {
                GameObjectManager.drawWall(this._beginWallsSelected[i], true, false, false);

            }
        }

        if (this._anglesToDraw !== null) {
            for (i = 0; i < this._anglesToDraw.length; i++) {
                var wallEdited = this._anglesToDraw[i][0];
                var walls = this._anglesToDraw[i][1];

                var point = SavaneMath.findCommonPoint(wallEdited, walls[0]);

                var angle = wallEdited.getWallAngle(wallEdited.isBegin(point));
                var angleJ = walls[0].getWallAngle(walls[0].isBegin(point));
                var minAngle = Math.min(Math.abs(angleJ - angle), 2 * Math.PI - Math.abs(angleJ - angle));
                var index = 0;
                for (j = 0; j < walls.length; j++) {
                    angleJ = walls[j].getWallAngle(walls[j].isBegin(point));
                    if (minAngle > Math.min(Math.abs(angleJ - angle), 2 * Math.PI - Math.abs(angleJ - angle))) {
                        minAngle = Math.min(Math.abs(angleJ - angle), 2 * Math.PI - Math.abs(angleJ - angle));
                        index = j;
                    }
                }

                GameObjectManager.drawAngle(this._anglesToDraw[i][0], this._anglesToDraw[i][1][index], zoom);
            }
        }
        this._endWallsSelected = wallsSelected;

        if (this._endWallsSelected !== null) {
            for (i = 0; i < this._endWallsSelected.length; i++) {
                GameObjectManager.drawWall(this._endWallsSelected[i], true, false, false);
            }
        }
    }

    mouseClickCancelled (cursorPosition: math.vec3): ActionState {
        for (var i = 0; i < this._wallsEdited!.length; i++) {
            var wall = this._wallsEdited![i];
            var node = EntityManager.getInstance().getNode(wall);
            node!.setHovered(false);
        }
        PlanManager.getInstance().updateItemsSelected(null);
        eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);
        return new IdleConstruction();
    }

    keyPressed (keyCode: number, ctrl?: boolean, alt?: boolean): ActionState | null {
        if (keyCode == cc.KEY.escape) {
            for (var i = 0; i < this._wallsEdited!.length; i++) {
                var wall = this._wallsEdited![i];
                var node = EntityManager.getInstance().getNode(wall);
                node!.setHovered(false);
            }
            PlanManager.getInstance().updateItemsSelected(null);
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);
            return new IdleConstruction();
        }

        return null;
    }

    snapClick(): ActionState {
        return new IdleConstruction();
    }

    dispose() {
        var i;
        if (!this.editionDone) {
            GameObjectManager.deleteJunctionPoint(EditPointState.EDITED_POINT_NODE_NAME);
            for (i = 0; i < this._wallsEdited!.length; i++) {
                this._wallsEdited![i].endTemporary();
            }
            for (i = 0; i < this._wallsEdited!.length; i++) {
                GameObjectManager.drawWall(this._wallsEdited![i], true, false, false);
                this._wallsEdited![i].recomputeJoineriesPosition();
            }
            GameObjectManager.updateRooms(this.roomsToUpdate);

            if (this._anglesToDraw !== null) {
                for (i = 0; i < this._anglesToDraw.length; i++) {
                    GameObjectManager.deleteAngle(this._anglesToDraw[i][0]);
                }
            }
        }
    }
}
